import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import { Grid, InputAdornment, SvgIcon } from '@mui/material';
import { useEffect, useState } from 'react';

import { gridSize, gridSizeMdLg12, gridSizeMdLg6, useLoaders, useMapComponent } from '@/shared';
import { IconBtnModalMapComponent } from '@/shared/components/erp';
import {
  CustomAutocomplete,
  CustomCircularPorgress,
  CustomNumberTextField,
  CustomTextArea,
  CustomTextField,
  CustomTextFieldNoForm,
  SampleCheckbox,
  SingleIconButton,
  TabTextLabel,
} from '@/shared/components/ui';
import {
  AlertSeverityEnum,
} from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import GlobeEuropeAfricaIcon from '@heroicons/react/24/solid/GlobeEuropeAfricaIcon';
import { Naps, PuertoNap } from '@/shared/interfaces';
import { IOrdenServicioCorporativo } from '@/shared/interfaces/erp/orden_servicio_corporativo';

export type OTDeralleInstallTecnicoCorporativoFormTabProps = {
  //form: UseFormReturn<SaveFormDataInstallTecAsig, any>;
  form: any
  errors: any
  shrink: boolean
  coords: string
  ordenTrabajo: IOrdenServicioCorporativo
  isOnlyView?: boolean

  canDragMarker?: boolean
  canRuler?: boolean
};

const OTDeralleInstallTecnicoCorporativoFormTab: React.FC<
  OTDeralleInstallTecnicoCorporativoFormTabProps
> = ({
  form,
  errors,
  shrink,
  coords,
  ordenTrabajo,
  isOnlyView = false,
  canDragMarker = false,
  canRuler = false,
}) => {
    ///* hooks -----------------------
    // const queryClient = useQueryClient();

    // const isRequestSent =
    //   ordenTrabajo?.estado_activacion ===
    //   EstadosActivacionInstallOTEnumChoice.PENDIENTE_CAMBIO_PUERTO;

    ///* local state -----------------------
    const [canChangeNap, setCanChangeNap] = useState(false);
    const [isSetAll, setIsSetAll] = useState(false);

    ///* global state -----------------------
    // ya no se hace solicitud cambio puerto
    // const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
    // const setConfirmDialogIsOpen = useUiConfirmModalStore(
    //   s => s.setConfirmDialogIsOpen
    // );
    // const setIsGlobalLoading = useUiStore(s => s.setIsGlobalLoading);
    const setAlert = useUiStore(s => s.setAlert);

    ///* form -----------------------
    const watchedRawNap = form.watch('rawNap') as Naps;
    const watchedPort = form.watch('puerto');
    const watchedCoords = form.watch('coordenada_servicio');

    const onChangeMarker = () => {
      if (isOnlyView) return;
      if (!isSetAll) return;

      form.reset({
        ...form.getValues(),
        nap: '',
        puerto: ''
      });
      /* form.setValue('nap', '');
      form.setValue('puerto', ''); */
      setCanChangeNap(true);
    };

    // map ------------------------
    const {
      Map,
      latLng,
      setLatLng,
      isLoadingNapsByCity: isLoadingNaps,
      isRefetchingNapsByCity: isRefetchingNaps,
      napsByCity,
      setCurrentCoordenadas,
    } = useMapComponent({
      form,
      currentCity: '', // replaced by coordenadasCliente
      distanciaNapKey: 'distancia',
      // coordenadasCliente: coords || '',
      // enabledFetchNaps: !!coords,
      coordenadasCliente: watchedCoords || '',
      enabledFetchNaps: !!watchedCoords,
      onChangeMarker,
    });

    ///* effects ---------------
    useEffect(() => {
      if (isLoadingNaps || isRefetchingNaps || !ordenTrabajo || isSetAll) return;

      form.reset({
        ...form.getValues(),
        nap: ordenTrabajo?.nap || '',
        puerto: ordenTrabajo?.puerto || '',
        distancia: ordenTrabajo?.distancia || ''
      })
      setIsSetAll(true);
    }, [isLoadingNaps, ordenTrabajo]);

    useLoaders(isLoadingNaps || isRefetchingNaps || !ordenTrabajo);

    return (
      <>
        {/* ------------- Bobina y Cable ------------- */}
        {/* <TabTextLabel text="Bobina y Detalle Cable" pb="24px" pt="12px" />
        <>
          <CustomTextField
            label="Código Bobina"
            name="codigo_bobina"
            control={form.control}
            defaultValue={form.getValues().codigo_bobina || ''}
            error={form.formState.errors.codigo_bobina}
            helperText={form.formState.errors.codigo_bobina?.message || ''}
            disabled={isOnlyView}
          />
          <CustomTextField
            name="splitter"
            label="Splitter"
            control={form.control}
            defaultValue={form.getValues().splitter || ''}
            error={errors.splitter}
            helperText={errors.splitter?.message || ''}
            size={gridSizeMdLg6}
            disabled={isOnlyView}
          />
          <CustomTextField
            name="manga"
            label="Manga"
            control={form.control}
            defaultValue={form.getValues().manga || ''}
            error={errors.manga}
            helperText={errors.manga?.message || ''}
            size={gridSizeMdLg6}
            disabled={isOnlyView}
          />
          <CustomTextField
            name="color_hilo"
            label="Color Hilo"
            control={form.control}
            defaultValue={form.getValues().color_hilo || ''}
            error={errors.color_hilo}
            helperText={errors.color_hilo?.message || ''}
            size={gridSizeMdLg6}
            disabled={isOnlyView}
          />
          <CustomTextField
            name="num_hilo"
            label="Número Hilo"
            control={form.control}
            defaultValue={form.getValues().num_hilo || ''}
            error={errors.num_hilo}
            helperText={errors.num_hilo?.message || ''}
            size={gridSizeMdLg6}
            disabled={isOnlyView}
          />
        </> */}

        {/* ------------- NAP y Detalle Activacion ------------- */}
        <TabTextLabel text="NAP Y DETALLES ACTIVACIÓN" pb="24px" pt="12px" />
        <>
          <Grid item xs={12} container spacing={2} alignItems="center">
            <Grid item xs={12} md={11}>
              <CustomTextField
                type="coordenada"
                control={form.control}
                name="coordenada_servicio"
                defaultValue={form.getValues().coordenada_servicio || ''}
                size={gridSize}
                label="Coordenadas del Servicio"
                error={errors.coordenadas}
                startAdornment={
                  <InputAdornment position="start">
                    <SvgIcon fontSize="small">
                      <GlobeEuropeAfricaIcon />
                    </SvgIcon>
                  </InputAdornment>
                }
                helperText={errors.coordenadas?.message}
                onChangeValue={(e, v) => {
                  if (isOnlyView) return;

                  if (v) {
                    let s = e.split(',');
                    setLatLng({ lat: s[0], lng: s[1] });
                    setCurrentCoordenadas(e);
                  }

                  form.reset({
                    ...form.getValues(),
                    nap: '',
                    puerto: '',
                  });
                  setCanChangeNap(true);
                }}
                disabled={isOnlyView}
              />
            </Grid>

            <Grid item xs={12} md={1}>
              <IconBtnModalMapComponent
                coords={`${latLng.lat},${latLng.lng}` || `${coords}` || ''}
                btnColor="info"
                showCustomMap
                customMap={
                  <Map
                    coordenadas={latLng}
                    napsByCity={napsByCity || []}
                    setLatLng={setLatLng}
                    canDragMarker={canDragMarker}
                    canRuler={canRuler}
                  />
                }
              />
            </Grid>
          </Grid>
        </>

        <>
          {isLoadingNaps || isRefetchingNaps ? (
            <Grid
              item
              container
              xs={12}
              justifyContent="center"
              alignItems="center"
              my={2}
            >
              <CustomCircularPorgress />
            </Grid>
          ) : (
            <Grid item container xs={12} alignItems="center" spacing={2}>
              <Grid item xs={12} md={6}>
                <CustomAutocomplete<Naps>
                  label="NAP"
                  name="nap"
                  valueKey="nombre"
                  actualValueKey="codigo"
                  defaultValue={form.getValues().nap || ''}
                  // options
                  options={napsByCity || []}
                  isLoadingData={isLoadingNaps}
                  // validation
                  control={form.control}
                  error={errors.nap}
                  helperText={errors.nap?.message}
                  size={gridSize}
                  disabled={!canChangeNap || isOnlyView}
                  disableClearable
                  onChangeRawValue={nap => {
                    if (!nap) return;
                    form.reset({
                      ...form.getValues(),
                      rawNap: nap,
                      puerto: '',
                      distancia: nap?.distancia?.toString() || '',
                    });
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6} container alignItems="center">
                <Grid item xs={12} md={11}>
                  {!canChangeNap ? (
                    <CustomTextFieldNoForm
                      label="Puerto"
                      value={watchedPort || ''}
                      disabled
                      size={gridSize}
                    />
                  ) : (
                    <>
                      <CustomAutocomplete<PuertoNap>
                        label="Puerto"
                        name="puerto"
                        // options
                        options={
                          watchedRawNap?.puertos?.filter(
                            puerto =>
                              !puerto?.estado ||
                              puerto?.puerto.toString() ===
                              ordenTrabajo?.puerto?.toString()
                          ) as PuertoNap[] || []
                        }
                        valueKey="puerto"
                        actualValueKey="puerto"
                        defaultValue={ordenTrabajo?.puerto?.toString() || ''}
                        isLoadingData={false}
                        // validation
                        control={form.control}
                        error={errors.puerto}
                        helperText={errors.puerto?.message}
                        size={gridSize}
                        disableClearable
                      />
                    </>
                  )}
                </Grid>

                <Grid item xs={12} md={1}>
                  <SingleIconButton
                    startIcon={<ChangeCircleIcon />}
                    color={!canChangeNap ? 'primary' : 'warning'}
                    label={canChangeNap ? 'Cancelar' : 'Cambiar NAP/Puerto'}
                    onClick={() => {
                      if (isOnlyView) {
                        setAlert(
                          true,
                          'No puedes cambiar el NAP/Puerto en modo vista',
                          AlertSeverityEnum.info
                        );
                        return;
                      }

                      // if cancel set puerto to default
                      if (canChangeNap) {
                        form.reset({
                          ...form.getValues(),
                          puerto: ordenTrabajo?.puerto?.toString() || '',
                          distancia: ordenTrabajo?.distancia || '',
                          nap: ordenTrabajo?.nap?.toString() || '',
                          rawNap: ordenTrabajo?.nap_data || {},
                          coordenadas: ordenTrabajo?.coordenadas || '',
                        });

                        setCurrentCoordenadas(ordenTrabajo?.coordenadas || '');
                      }

                      setCanChangeNap(canChangeNap ? false : !canChangeNap);
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}

          <CustomNumberTextField
            label="Distancia a la NAP"
            name="distancia"
            //register={form.register('distancia')}
            error={errors.distancia}
            helperText={errors.distancia?.message}
            shrink={shrink}
            control={form.control}
            defaultValue={form.getValues().distancia || ''}
            endAdornment={<InputAdornment position="end">metros</InputAdornment>}
            disabled
            size={gridSizeMdLg6}
          />

          {/* ----- Datos ----- */}
          <>

            <CustomTextField
              name="ipv4_actual"
              label="IPv4"
              control={form.control}
              defaultValue={form.getValues().ipv4_actual || ''}
              error={form.formState.errors.ipv4_actual}
              helperText={form.formState.errors.ipv4_actual?.message || ''}
              shrink={shrink}
              disabled
              size={gridSizeMdLg6}
            />
            <CustomTextField
              name="ipv6_actual"
              label="IPv6"
              control={form.control}
              defaultValue={form.getValues().ipv6_actual || ''}
              error={form.formState.errors.ipv6_actual}
              helperText={form.formState.errors.ipv6_actual?.message || ''}
              shrink={shrink}
              disabled
              size={gridSizeMdLg12}
            />
            <CustomTextField
              name="pppoe"
              label="PPPoE"
              control={form.control}
              defaultValue={form.getValues().pppoe || ''}
              error={form.formState.errors.pppoe}
              helperText={form.formState.errors.pppoe?.message || ''}
              disabled
              size={gridSizeMdLg6}
            />
            <CustomTextField
              name="pppassword"
              label="PPPassword"
              control={form.control}
              defaultValue={form.getValues().pppassword || ''}
              error={form.formState.errors.pppassword}
              helperText={form.formState.errors.pppassword?.message || ''}
              size={gridSizeMdLg6}
              disabled
            />
            {/* <CustomTextFieldNoForm
            label="Router AC"
            value={ordenTrabajo?.es_router_ac ? 'SÍ' : 'NO'}
            disabled
            size={gridSizeMdLg6}
          /> */}

            {/* -------- otros -------- */}
            <CustomTextField
              name="test_5g"
              label="Test 5G"
              control={form.control}
              defaultValue={form.getValues().test_5g || ''}
              error={errors.test_5g}
              helperText={errors.test_5g?.message || ''}
              disabled={isOnlyView}
            />

            <CustomNumberTextField
              name="potencia_dbm"
              label="Potencia DBM"
              control={form.control}
              defaultValue={form.getValues().potencia_dbm || ''}
              error={errors.potencia_dbm}
              helperText={errors.potencia_dbm?.message || ''}
              size={gridSizeMdLg6}
              disabled={isOnlyView}
            />
            <CustomNumberTextField
              name="potencia_ont"
              label="Potencia ONT"
              control={form.control}
              defaultValue={form.getValues().potencia_ont || ''}
              error={errors.potencia_ont}
              helperText={errors.potencia_ont?.message || ''}
              size={gridSizeMdLg6}
              disabled={isOnlyView}
            />
            <CustomTextField
              name="olt"
              label="OLT"
              control={form.control}
              defaultValue={form.getValues().olt || ''}
              error={errors.olt}
              helperText={errors.olt?.message || ''}
              disabled
            />

            <SampleCheckbox
              label="Tiene conexión a tierra"
              name="es_conexion_tierra"
              control={form.control}
              defaultValue={!!form.getValues().es_conexion_tierra}
              size={gridSizeMdLg6}
              sxChecbox={{ pb: 2 }}
              disabled={isOnlyView}
            />
            <SampleCheckbox
              label="Tiene regulador"
              name="es_regulador"
              control={form.control}
              defaultValue={!!form.getValues().es_regulador}
              size={gridSizeMdLg6}
              sxChecbox={{ pb: 2 }}
              disabled={isOnlyView}
            />

            {/* -------- ubicacion equipos -------- */}
            <CustomTextArea
              name="ubicacion_equipo_ac"
              label="Ubicación Equipo AC"
              control={form.control}
              defaultValue={form.getValues().ubicacion_equipo_ac || ''}
              error={errors.ubicacion_equipo_ac}
              helperText={errors.ubicacion_equipo_ac?.message || ''}
              disabled={isOnlyView}
            />
            <CustomTextArea
              name="ubicacion_ont"
              label="Ubicación ONT"
              control={form.control}
              defaultValue={form.getValues().ubicacion_ont || ''}
              error={errors.ubicacion_ont}
              helperText={errors.ubicacion_ont?.message || ''}
              disabled={isOnlyView}
            />

            <CustomTextArea
              label="Observación Activación"
              name="observacion_activacion"
              control={form.control}
              defaultValue={form.getValues().observacion_activacion || ''}
              error={errors.observacion_activacion}
              helperText={errors.observacion_activacion?.message || ''}
              disabled
            />
          </>
        </>
      </>
    );
  };

export default OTDeralleInstallTecnicoCorporativoFormTab;
